import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, IconButton } from "@material-ui/core";
import TwitterIcon from "@material-ui/icons/Twitter";
import TelegramIcon from "@material-ui/icons/Telegram";

const useStyles = makeStyles((theme) => ({
  footer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
    backgroundColor: "rgb(1, 6, 25)", // Dark background matching the navbar
    color: "#ffffff", // White text for contrast
  },
  iconButton: {
    margin: "0 1rem", // Space between icons
    color: "#ffffff", // Default color for the icons (white)
    "&:hover": {
      color: "#ff0080", // Neon pink on hover
    },
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <Box className={classes.footer}>
      <a href="https://x.com/misfitscoinsol" target="_blank" rel="noopener noreferrer">
        <IconButton className={classes.iconButton}>
          <TwitterIcon fontSize="large" />
        </IconButton>
      </a>
      {/* <a href="https://t.me/yourprofile" target="_blank" rel="noopener noreferrer">
        <IconButton className={classes.iconButton}>
          <TelegramIcon fontSize="large" />
        </IconButton>
      </a> */}
    </Box>
  );
};

export default Footer;
